import script from "./EventPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPublic.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/clubstyle.css?vue&type=style&index=0&lang=css&external"
import "./EventPublic.vue?vue&type=style&index=1&id=f192e578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f192e578"]])

export default __exports__